import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetPharmacy(id: string | undefined) {
  return useQuery(queries.pharmacies.getPharmacyById(id || ''))
}
